import React, { memo } from "react";
import { PhotoLibraryIcons } from "../../../../utils/B2B/PhotoLibraryContent";
import { IUploadingFile } from "../../../../interfaces/photoLibrary";
import "./PhotoLibraryUploadProgress.scss";

interface PhotoLibraryUploadProgressProps {
	uploadingFiles: IUploadingFile[];
	onRemoveUpload: (uploadId: string) => void;
}

const PhotoLibraryUploadProgress: React.FC<PhotoLibraryUploadProgressProps> = ({
	uploadingFiles,
	onRemoveUpload,
}) => {
	if (uploadingFiles.length === 0) return null;

	return (
		<div className="uploading-section">
			{uploadingFiles.map((upload) => (
				<div key={upload.id} className="upload-progress-item">
					<div className="upload-icon">
						<PhotoLibraryIcons.Upload />
					</div>
					<div className="upload-info">
						<div className="upload-name">{upload.file.name}</div>
						<div className="progress-bar-small">
							<div className="progress-fill-small" style={{ width: `${upload.progress}%` }} />
						</div>
					</div>
					<div className="upload-percent">{upload.progress}%</div>
					<div className="upload-close-btn" onClick={() => onRemoveUpload(upload.id)}>
						<PhotoLibraryIcons.Close />
					</div>
				</div>
			))}
		</div>
	);
};

export default memo(PhotoLibraryUploadProgress);

